module.exports = __webpack_public_path__ + "img/3.747124a6.webp";